import { memo, useCallback } from 'react';

import { Flex, Label, Separator, Text, TextField } from '@/components/core';
import { TextArea } from '@/components/core';
import { findField, FormatterValidatorHeader, ValidationFormSettings } from '@/components/ui';
import { useDebounceCallback, useValidatorMutation } from '@/hooks';
import { useModelConfigStore } from '@/store';

export type RegexValidatorProps = {
  fieldId: string;
  validatorId: string;
};

const IRegexValidator = ({ fieldId, validatorId }: RegexValidatorProps) => {
  const field = useModelConfigStore((state) => findField(state.fields, fieldId));
  const mutate = useValidatorMutation({ fieldId, validatorId, parentId: field?.parentId });
  const validator = field?.validators?.find((v) => v.id === validatorId);

  const onSetMatchPattern = useDebounceCallback(
    useCallback(
      (value: string) => {
        mutate((f) => (f.config.matchPattern = value));
      },
      [mutate]
    ),
    500
  );

  return (
    <div className="flex h-full flex-col gap-4 p-4">
      <FormatterValidatorHeader validator={validator} />
      <Separator orientation="horizontal" />

      <Flex col className="gap-sm">
        <TextField defaultValue={validator?.config.matchPattern?.toString()} onChange={onSetMatchPattern}>
          <Label>Match pattern</Label>
          <TextArea placeholder="Example: ^(.*) Corp$" />
        </TextField>

        <Text slot="description">
          <a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_expressions/Cheatsheet">
            See here for more details and examples.
          </a>
        </Text>
      </Flex>

      <ValidationFormSettings fieldId={fieldId} validatorId={validatorId} />
    </div>
  );
};

export const RegexValidator = memo(IRegexValidator) as typeof IRegexValidator;
